import React from "react";

const PartyPackages = () => {
  return (
    <section className="bg-black px-5 sm:px-14 md:px-16 lg:px-20">
      <div className="text-center text-2xl font-bold text-white mb-6">Party Packages</div>
      <div className="text-center text-white text-lg">
        CHOOSE YOUR UNLIMITED PARTY PACKAGES - CONTACT US - 9289426516,
        8527221291
      </div>
      <div className="text-center text-white text-base my-3">(SERVING TIME 3 HOURS )</div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        <div className="border-white border text-white rounded-sm p-3">
          <div className="text-red-500 font-bold text-center text-xl">
            IMFL PACKAGE-2000
          </div>
          <div className="text-center text-xs">Inclusive of Food Package</div>
          <div className="text-center text-xs">
            (Choose one from each Category)
          </div>
          <div className="text-xs font-bold text-center my-3">WHISKEY</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              TEACHER HIGHLAND
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              OLD SMUGGLER
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">GIN</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              GREATER THAN
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">VODKA</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              ONE MORE
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">RUM</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              BICARDI WHITE
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              OLD MONK
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">BEER</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              KINGFISHER ULTRA
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              KINGFISHER PREMIUM
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">BIRA</li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              MOCKTAILS
            </li>
          </ul>
        </div>
        <div className="border-white border text-white rounded-sm p-3">
          <div className="text-red-500 font-bold text-center text-xl">
            DELUXE PACKAGE-2800
          </div>
          <div className="text-center text-xs">Inclusive of Food Package</div>
          <div className="text-center text-xs">
            (Choose one from each Category)
          </div>
          <div className="text-xs font-bold text-center my-3">WHISKEY</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              JW RED LABEL
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              JIM BEAM
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">GIN</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              BOMBAY SAPPHIRE
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">VODKA</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              SMOKE LAB CLASSIC
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">RUM</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              BICARDI WHITE
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              OLD MONK
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">BEER</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              BUDWEISER
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              KINGFISHER ULTRA
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">BIRA</li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              MOCKTAILS
            </li>
          </ul>
        </div>
        <div className="border-white border text-white rounded-sm p-3">
          <div className="text-red-500 font-bold text-center text-xl">
            IMPORTED PACKAGE-3500
          </div>
          <div className="text-center text-xs">Inclusive of Food Package</div>
          <div className="text-center text-xs">
            (Choose one from each Category)
          </div>
          <div className="text-xs font-bold text-center my-3">WHISKEY</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              JW BLACK LABEL
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              MONKEY SHOULDER
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">VODKA</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              SMOKE LAB CLASSIC
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">RUM</div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              BICARDI WHITE
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              OLD MONK
            </li>
          </ul>
          <div className="text-xs font-bold text-center mt-4 mb-2">
            BEER\WINE
          </div>
          <ul className="flex gap-2 flex-wrap justify-center">
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              BUDWEISER
            </li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">CORONA</li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">WINE</li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">BIRA</li>
            <li className="bg-gray-900 rounded-md py-1 px-2 text-sm">
              COCKTAILS+MOCKTAILS
            </li>
          </ul>
        </div>
      </div>
      <div className="text-center text-white text-base mt-9 mb-3">
        FOOD PACKAGE-1500 P.P.3+3 (STARTER)
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2">
        <div className="border border-white text-white rounded-sm p-3">
          <div className="text-center text-red-500 text-xl font-bold">VEG</div>
          <ul className="flex justify-center flex-wrap gap-2">
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CURD KABAB
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CHEESE BALL
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              PANEER TIKKA
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CIGAR ROLL
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CHILLY PANEER
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              VEG PIZZA
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              HONEY CHILLI POATATO
            </li>
            <li className="bg-gray-900 rounded-md-py-1 px-2">SOYA CHAP</li>
            <li className="bg-gray-900 rounded-md-py-1 px-2">
              CHILLY MUSHROOM
            </li>
            <li className="bg-gray-900 rounded-md-py-1 px-2">
              HIRYALI PANEER TIKKA
            </li>
             <li className="bg-gray-900 rounded-md-py-1 px-2">
               SAUTE VEGETABLES
            </li>
          </ul>
        </div>
        <div className="border border-white text-white rounded-sm p-3">
          <div className="text-center text-red-500 text-xl font-bold">
            NON-VEG
          </div>
          <ul className="flex justify-center flex-wrap gap-2">
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              FISH TIKKA
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              FISH FINGER
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CHICKEN MALLAI TIKKA
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              TANDOORI CHICKEN TIKKA
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              PATYA CHICKEN WINGS
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              BASIL CHICKEN
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CHILLI CHICKEN
            </li>
            <li className="bg-gray-900 rounded-md-py-1 px-2">NON-VEG PIZZA</li>
            <li className="bg-gray-900 rounded-md-py-1 px-2">
              BLACK PEPPER CHICKEN
            </li>
            <li className="bg-gray-900 rounded-md-py-1 px-2">
              SIRACHA CHICKEN
            </li>
            CHICKEN 65
          </ul>
        </div>
      </div>
      <div className="text-center text-white text-base mt-9 mb-3">
        CHOOSE ANY-1200 P.P.2+2 (MAIN COURSE)
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2">
        <div className="border border-white text-white  rounded-sm p-3">
          <div className="text-center text-red-500 text-xl font-bold">VEG</div>
          <ul className="flex justify-center flex-wrap gap-2">
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              DAL MAKHANI
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
             KADHAI PANEER RAGAN JOSH
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              MIXED VEG CHICKEN GRAVY
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
             DAL TADKA
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              VEG THAI CURRY RED\GREEN
            </li>
           <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CHILLI PANEER GRAVY
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              PANEER LABADAR CURRY
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              VEG FRIED RICE
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              PENNE VEG PASTA
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              HAKKA NOODLES
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              MIXED VEG IN HOT GARLIC SAUCE
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              VEG MANCHURIYAN
            </li>
          </ul>
        </div>
        <div className="border border-white text-white rounded-sm p-3">
          <div className="text-center text-red-500 text-xl font-bold">
            NON-VEG
          </div>
          <ul className="flex justify-center flex-wrap gap-2">
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CHICKEN THAI CURRY GREEN/RED
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              BUTTER CHICKEN
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
               CHILLY CHICKEN
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              KADHAI CHICKEN
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
             MUTTON
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CHICKEN LABADAR
            </li>
            <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
              CHICKEN PASTA PENNE
            </li>
            <li className="bg-gray-900 rounded-md-py-1 px-2">
              CHILLY MANCHURIYAN
            </li>
           
          </ul>
        </div>
      </div>

      <div className="text-center text-white mt-9">
        ASSORTED INDIAN BREADS & STEAM RICE
      </div>

      <div className="text-center text-white text-base mt-9 mb-3">
        DESSERT CHOOSE ANY ONE
      </div>
      <div className="border border-white text-white rounded-sm p-3">
        <ul className="flex justify-center flex-wrap gap-2">
          <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
            BROWNIE WITH ICE CREAM
          </li>
          <li className="bg-gray-900 rounded-md py-1 text-sm px-2">
            GULAB JAMUN WITH ICE CREAM
          </li>
        </ul>
      </div>
      <div className="text-center text-white my-9">
        NOTE-WATER BOTTLE,COKECAN,TONIC WATER,RED BULL NOT INCLUDED IN THE
        PACKAGES…TERMS&CONDITION APPLY
      </div>
      <div className="text-white">
        <div className="text-center">PLEASE NOTE:</div>
        <ul>
          <li>
            1. Food & beverages package service validated for 3 hours of
            service.
          </li>
          <li>2. Last food & beverages order will be taken at 12:00.am</li>
          <li>
            3. Music policy- music will be played as per restaurant policy.
          </li>
          <li>
            4. Red bull & caned beverages will be charged as per consumption
          </li>
          <li>5. Guest list to be shared with us before the event starts.</li>
          <li>
            6. Minimum guarantee amount to be paid before the service starts.
          </li>
          <li>7. Alcohol is not allowed below 25 years of age group.</li>
          <li>
            8. Food (main course) will be placed as per the package
            timings/evening before 11:00pm.
          </li>
          <li>
            9. Anything apart from the package will be charge as per
            consumption.
          </li>
          <li>
            10. Any kind of liquor(outside)will not be permitted inside the
            premises not in any kind of form(return gift)
          </li>
          <li>
            11. Party payment would be cash either bill 5% GST/VATS chargeable.
          </li>
          <li>
            12. Dress Code. FOLLOWING DRESSES ARE NOT ALLOWED INSIDE THE
            BAR,CLUB PREMISES. SHORTS; BERMUDAS; PATHANI SUIT; CHAPPALS/
            SLIPPERS; GYM DRESSES.
          </li>
          <li>
            13. Address: 2nd Floor, G-24, South Extension I, New Delhi, Delhi
            110049
          </li>
        </ul>
      </div>
     
        <div className="text-center text-white my-9">
          FEEL FREE TO CONTACT THE UNDERSIGNED FOR ANY FURTHER QUERIES.
        </div>
      <div className="text-sm text-white text-center">
        (Gvt. Taxes as applicable) (we levy 10% service charge)
      </div>
      <div className="text-sm text-white text-center my-2">
        Note - Terms & condition apply
      </div>
      <div className="text-center text-white">&copy;2025 classycafebar.Made with💖</div>
    </section>
  );
};

export default PartyPackages;
